import { MouseEvent } from 'react';
import { Box, Table, Tooltip, useClipboard } from '@robocorp/components';
import { useTranslation } from 'react-i18next';
import { TextOverflow } from '~/components';

const onPropagatedClick = (action: () => void) => (event: MouseEvent) => {
  event.stopPropagation();
  action();
};

interface Props {
  id: string;
}

export const WorkItemIdCell: React.FC<Props> = ({ id }) => {
  const { onCopyToClipboard, copiedToClipboard } = useClipboard();
  const { t } = useTranslation();

  return (
    <Table.Cell onClick={onPropagatedClick(onCopyToClipboard(id))} maxWidth={160}>
      <Box>
        <Tooltip
          maxWidth={420}
          text={t(copiedToClipboard ? 'copiedValueToClipboard' : 'copyValueToClipboard', {
            value: id,
          })}
        >
          <TextOverflow maxWidth="100%">{id}</TextOverflow>
        </Tooltip>
      </Box>
    </Table.Cell>
  );
};
